import { Grid } from "@mui/material";
import HTMLRenderer from "components/common/HTMLRenderer";
import Typography from "components/common/Typography";
import { uniqueId } from "lodash";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import Links from "../../common/linksButton";

export default function Index() {
  const activeCard: any = useAppSelector((state) => state.app.activeActionCard);
  const { body, summary, linkToResources, embeddedMedia } = activeCard;

  return (
    <Grid container display="flex" flexDirection="column" sx={{ padding: "24px" }}>
      <Typography variant="body1">{summary}</Typography>
      <HTMLRenderer content={body} />
      <HTMLRenderer content={embeddedMedia} />

      <Grid item display="flex" flexDirection="column" alignItems="space-between" marginTop="15px">
        {linkToResources && (
          <>
            <Typography color={tokens.Text.General.PrimaryBody} showBold>
              Resources
            </Typography>
            <Grid>
              {linkToResources?.map((element: any) => {
                return (
                  <Links
                    key={uniqueId("RESOURCE_")}
                    title={element?.title}
                    url={element?.url}
                    openInNewTab={element?.openInNewTab}
                    id={element.id}
                    activeCard={activeCard}
                  />
                );
              })}
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  );
}
